module.exports = __webpack_public_path__ + "static/media/resetnum.4a14eb96.svg";